export const getColumns = () => {
  return [
    {
      field: "picker_name",
      headerName: "Picker Name",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "total_picked",
      headerName: "Total Picked",
      flex: 0.5,
      minWidth: 100,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avg_time_spent",
      headerName: "Average Time Spent",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const value = params.row.avg_time_spent;
        if (value === null || value === undefined || value === "") return "";

        try {
          // Check if the value is a valid number or numeric string
          const numValue = parseFloat(value);
          if (isNaN(numValue)) return value;

          // Convert seconds to HH:MM:SS format
          const totalSeconds = Math.floor(numValue);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        } catch (error) {
          // If there's an error in formatting, return the raw value
          return value;
        }
      },
    },
  ];
};
